import SntCheckIcon from "@icons/SntCheckIcon";
import SntCloseIcon from "@icons/SntCloseIcon";

const CheckView = ({ value }) => {
  if (value === null || value === undefined) return "";

  if (typeof value === "boolean") {
    return value ? <SntCheckIcon /> : <SntCloseIcon />;
  }

  if (typeof value === "string") {
    if (value.toUpperCase() === "FALSE") {
      return <SntCloseIcon />;
    } else if (value.toUpperCase() === "TRUE") {
      return <SntCheckIcon />;
    }
  }

  return value ? <SntCheckIcon /> : <SntCloseIcon />;
};

export default CheckView;
